import widgets from '../../widgets';
import icons from '../../../icons';
import { innerInstructionCard } from './innerInstructionCard';
import { ReactiveMLComponent } from '../../config_ui/config_components/base_components';
import './fsm.css';

class ReactiveInstructionComponent extends ReactiveMLComponent {
  constructor({
    createElement,
    container,
    state,
    applicationListenerNames,
    instructionListenerNames,
    sequenceListenersNames
  }) {
    super({createElement, container, state});
    const {instruction, application} = state;

    this.mInstruction = instruction;
    this.mApplication = application;
    this.mApplicationListeners = {};
    this.mInstructionListeners = {};
    this.mSequenceListeners = {};

    if (applicationListenerNames) {
      applicationListenerNames.forEach((name) => {
        this.mApplicationListeners[name] = this.render;
      });
      this.mApplication.addListener(this.mApplicationListeners);
    }

    if (instructionListenerNames) {
      instructionListenerNames.forEach((name) => {
        this.mInstructionListeners[name] = this.render;
      });
      this.mInstruction.addListener(this.mInstructionListeners);
    }

    if(sequenceListenersNames) {
      sequenceListenersNames.forEach((name) => {
        this.mSequenceListeners[name] = this.render;
      });
      this.mApplication.mSequences.forEach((pSequence) => {
        pSequence.addListener(this.mSequenceListeners);
      });
    }
  }

  cleanUp = () => {
    this.mApplication.removeListener(this.mApplicationListeners);
    this.mInstruction.removeListener(this.mInstructionListeners);
    this.mApplication.mSequences.forEach((pSequence) => {
      pSequence.removeListener(this.mSequenceListeners);
    });
  };
}


export const fsm = ({library, application, sequence, instruction}) => {
  const lLibrary = library;
  const lApplication = application;
  const lSequence = sequence;
  const lInstruction = instruction;

  const lInstructionWidget =  $('<div>').addClass('ml_instruction').addClass('h_layout');

  const lOnClose = () => {
    lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
  };

  const lCardLayout = widgets.card(
    icons.fsm,
    lOnClose,
    false,
    { showInstructionNumber: true, hideParameters: true }
  );

  const lCardContents = new ReactiveInstructionComponent({
    createElement: innerInstructionCard,
    state: {library: lLibrary, application: lApplication, sequence: lSequence, instruction: lInstruction},
    container: $('<div>'),
    instructionListenerNames: ['onParamUpdate'],
    sequenceListenersNames: ['onNameChanged']
  }).render();

  return lInstructionWidget.append(
    lCardLayout.append(
      $('<div>')
        .addClass('ml_fsm_state_container')
        .append( lCardContents ),
    )
  );
};
